function gameTeacher(appObj,game_conf){
    var spineResources;
    this.gameObj;
    var thm=this;
    
    function teacherGame(appObj,game_conf){
        this.mainObj=appObj;
        this.app=new PIXI.Application({
            width: 1280, height: 780,antialias: true,transparent:true,
            view:appObj[0]
        });
        this.boxes_all={};
        this.conf=copyObj(game_conf);
        this.teacher;
        this.val_need_real;
    }
    teacherGame.prototype={
        init:function(){


            var app=this.app;
            var thisObj=this;
            
            
            
            this.girl=new spineGirl(this.conf.girl_id);
            this.app.stage.addChild(this.girl);
            this.teacher=new spineTeacher(this.girl,this.mainObj);
            this.app.stage.addChild(this.teacher);
            
            
            this.addTable();
            var margin=[330,300],size=[850,280];
            var x,y;
            var row_count=6,column_count=4;
            var row_length=size[0]/row_count;
            var column_length=size[1]/column_count;
            var row,column,index=1;
            for(row=0;row<row_count;row++){
                for(column=0;column<column_count;column++){
                    x=Math.round(row_length/2+column*row_length);
                    x+=margin[0];
                    y=Math.round(column_length/2+row*column_length);
                    y+=margin[1];
                    this.boxes_all[index]=new cardBox(x,y,index);
                    this.boxes_all[index].init(function(index){
                        if(!_ON_DEV) {
                            //thisObj.chooseNumber(index);
                        }
                    });
                    this.app.stage.addChild(this.boxes_all[index]);
                    index++;
                }
            }
            var val_need_real=this.conf.val_need;
            if(typeof this.conf.state.val_need!="undefined"){
                val_need_real=this.conf.state.val_need;
            }
            this.val_need_real=val_need_real;
            this.textValNeed=new textBox(760,173,numberFormat(val_need_real,0,0));
            this.app.stage.addChild(this.textValNeed);
            
            this.textValCur=new textBox(509,173,0);
            this.app.stage.addChild(this.textValCur);
            
            this.beltObj=new progressBelt(function(){
                thisObj.nearlyToEnd();
            },function(){
                if(!_ON_DEV){
                    thisObj.failNumber(2);
                }
            });



            this.main_ticker=this.app.ticker.add(
                function(delta){thisObj.gameLoop(delta);}    
            );
            this.beltObj.init({fps:60});

            this.app.stage.addChild(this.beltObj);

            this.state={val_best:this.conf.repeat.val,moves:this.conf.repeat.moves,val_need:0,was_error:0};

//            var test=this.teacher;
//            app.stage.interactive = true;
//             app.stage.on('pointerdown', function() {
//                
//                test.hitGirl();
//                
//            });    
                
                
                
                
                
                

            this.mainObj.trigger("gameReady");


            _moduleEvents.one("moduleClear",function(){
                if(typeof app!="undefined" && app!=null){
                    app.destroy();
                }
            });
            $(appObj).on('click',function (e) {
                thisObj.clickEvent(e,margin,size,this);
            });
            $(appObj).on('touch',function (e) {
                thisObj.clickEvent(e,margin,size,this);
            });
            $(appObj).on('pointerdown',function (e) {
                thisObj.clickEvent(e,margin,size,this);
            });
        },
        clickEvent:function (e,margin,size,clickThis) {
            var mouseX,mouseY,offsetLeft=$(clickThis).offset().left,offsetTop=$(clickThis).offset().top,
            scale = _scaleObj.scale,scaleFixY=5,scaleFixX=0,scaleRounded=0;
            scaleRounded = Math.round(scale*10)/10;

            if(scaleRounded<1){
                offsetLeft = offsetLeft*scale;
                offsetTop = offsetTop*scale;

                scaleFixY = -30;
                scaleFixX = 20;
                if(scaleRounded<0.9 && scaleRounded > 0.7){
                    scaleFixX = 10;
                    scaleFixY = 30;
                } else {
                    scaleFixY = 60;
                    scaleFixX = 10;
                }
            }

            mouseX = Math.round(e.pageX - offsetLeft);
            mouseY = Math.round(e.pageY - offsetTop);

            if(mouseX>margin[0] && mouseX<margin[0]+size[0] && mouseY>margin[1]){
                for (var i in this.boxes_all) {
                    var box = this.boxes_all[i],
                        boxX=box.x,boxY=box.y,
                        boxWidth=box.width,boxHeight=box.height;

                    if(box.alpha<1){
                        continue;
                    }
                    if(scale>0) {
                        boxX = boxX * scale;
                        boxY = boxY * scale;
                        boxWidth = boxWidth * scale;
                        boxHeight = boxHeight * scale;
                    }
                    boxY+=scaleFixY;
                    boxX+=scaleFixX;
                    if((mouseX>boxX && mouseX<boxX+boxWidth) &&
                        (mouseY>boxY && mouseY<boxY+boxHeight)){
                        this.chooseNumber(i);
                        break;
                    }
                }
            }
        },
        addTable:function(){
            var cardTexture = PIXI.utils.TextureCache["table"];
            var cardImg=new PIXI.Sprite(cardTexture);
            cardImg.anchor.set(0,1);
            cardImg.x=0;
            cardImg.y=780;
            this.app.stage.addChild(cardImg);
        },
        takeState:function(){
            var res= {val:this.state.val_best,moves:this.state.moves,was_error:this.state.was_error};
            return res;
        },
        nextGame:function(step_wait){
            if(!step_wait){
                step_wait=0;
            }
            var conf={howlong:7000,howlong_appear:500,count_min:3,count_more:0};

            var moves=this.state.moves;
            var count_show=Math.round(this.conf.hard_row.card_lin.a*moves+this.conf.hard_row.card_lin.b);
            count_show=Math.min(count_show,this.conf.hard_row.card_max);
            var all_index=[],i;
            for(i in this.boxes_all){
                all_index.push(intval(i));
            }

            var arr_show=getRandomArrayElements(all_index,count_show);
            var index,val_max=0,val,step_start;
            var fps=this.main_ticker.FPS;
            fps=60;

            var val_start=Math.max(this.state.val_best,this.conf.state.val_start);
            this.state.val_best=val_start;
            
            var a_part=(this.conf.hard_row.moves-moves)/this.conf.hard_row.moves;
            a_part=Math.max(0.5,a_part);
            var a=this.conf.hard_row["val_lin"]["a"]*a_part;
            val_start=val_start+1;
            var val_need_max=val_start+Math.round(val_start*a)+this.conf.hard_row["val_lin"]["b"];
            var must_percent=0.9;
            var force_up=0,s,s_max=10,val_have_arr=[],random_arr=[];
            for(i in arr_show){
                index=arr_show[i];
                s=0;
                do{
                    s++;
                    random_arr=[val_start,val_need_max];
                    if((i==arr_show.length-2 && (val_max-val_start)/(val_need_max-val_start)<must_percent) || force_up){
                        //last
                        force_up=1;
                        random_arr=[val_start+Math.floor(must_percent*(val_need_max-val_start)),val_need_max];
                    }
                    val=mt_rand(random_arr[0],random_arr[1]);
                }
                while(in_array(val,val_have_arr) && s<s_max);
                val_have_arr.push(val);
                val_max=Math.max(val_max,val);
            }
            var val_series=copyArray(val_have_arr);
            var val_to_type={};
            val_series.sort(function(a,b){return a-b});
            for(i in val_series){
                val=val_series[i];
                if(this.conf.bonus2>0 && intval(i)+1>0.34*count_show){
                    val_to_type[val]="premium";
                }
                else{
                    val_to_type[val]="normal";
                }
            }
            
            for(i in arr_show){
                index=arr_show[i];
                val=val_have_arr[i];
                this.boxes_all[index].setNumber(val,val_to_type[val]);
                step_start=Math.round(conf.howlong_appear*intval(i)/(count_show-1)*fps/1000);
                this.boxes_all[index].setState("show",-step_start-step_wait);
            }
            
            
            this.state.val_need=val_max;
            this.beltObj.startBelt(conf.howlong,-step_wait);
        },
        succNumber:function(){
           if(this.state.was_error){
               return false;
           }
           this.beltObj.stopBelt();
           this.state.val_best=this.state.val_need;
           if(this.state.val_best>=this.val_need_real){
               this.textValNeed.setSucc();
               this.failNumber(3)
           }
           this.textValCur.setText(numberFormat(this.state.val_need,0,0))
           this.state.moves++;
           var i;
           for(i in this.boxes_all){
               this.boxes_all[i].setState("hide");
           }

            if(this.state.val_best<this.val_need_real){
               this.nextGame(50);
            }
           return true;
        },
        failNumber:function(was_error){
           this.beltObj.stopBelt();
           var i,bum;
           for(i in this.boxes_all){
               var bum=this.boxes_all[i];

               if(was_error==3 && bum.val>=this.state.val_need){
                   bum.setWinGame();
                   continue;
               }
               if(bum.val==this.state.val_need){
                   bum.setFail();
               } else {
                   bum.setState("hide");
               }
           } 
           this.state.was_error=was_error;
           this.teacher.hitGirl();
           
        },
        nearlyToEnd:function(){

        },
        chooseNumber:function(index){
            if(this.state.was_error>0){
                return false;
            }
            if(this.state.val_need==this.boxes_all[index].val){
                this.succNumber();
            }
            else{
                this.failNumber(1);
            }
            return true;

        },
        gameLoop:function(delta){
            this.inc+=delta;



            var i;
            for(i in this.boxes_all){
                this.boxes_all[i].updateState(delta);
            }
            this.beltObj.updateState(delta);
            this.girl.updateState(delta);
        }
    };
    function spineTeacher(girl,mainObj){
        PIXI.spine.Spine.call(this,spineResources.teacherGM.spineData);
        this.x=1040;
        this.y=540;
        
        
        this.myAnimLoop='standby2';
        this.animeQueue=[];
        this.curAnimName=this.myAnimLoop;
        this.state.setAnimation(0, this.myAnimLoop, true);
        this.myState=0;
        
        var thc=this;
        var conf_hit={"beat1":[0.65,0.9],"beat2":[0.95,1.15]};
        this.state.addListener({
            complete: function() {
                if(thc.animeQueue.length>0){
                    var anim_name=thc.animeQueue.shift();
                    thc.state.setAnimation(0, anim_name, false);
                    girl.willBeHit(conf_hit[anim_name][0],conf_hit[anim_name][1]);
                    thc.curAnimName=anim_name;
                    
                }
                else{
                    thc.state.setAnimation(0, thc.myAnimLoop, false);
                    if(thc.curAnimName!=thc.myAnimLoop){
                        mainObj.trigger("game_change");
                        thc.curAnimName=thc.myAnimLoop;
                    }
                    
                    
                }
            }
        });
        
    };
    spineTeacher.prototype = Object.create(PIXI.spine.Spine.prototype);
    spineTeacher.prototype= $.extend(spineTeacher.prototype,{
        hitGirl:function(){
            this.animeQueue.push("beat"+mt_rand(1,2));
        }
    });
    
    
    function spineGirl(girl_id){
        PIXI.spine.Spine.call(this,spineResources.girlGM.spineData);
        var girl_pos={
            "1":[290,720,0.8],
            "2":[250,650,0.72],
            "3":[250,690,0.72],
            "4":[270,670,0.72],
            "5":[240,650,0.72],
            "6":[240,670,0.72],
            "7":[240,670,0.72],
            "8":[220,670,0.72],
            "9":[240,670,0.72],
            "10":[270,670,0.75],
            "11":[270,670,0.72],
            "12":[270,670,0.72],
            "13":[270,670,0.72],
            "14":[270,670,0.72],
            "15":[250,670,0.72],
            "16":[270,670,0.72],
            "17":[250,670,0.69],
            "18":[270,670,0.72],
            "19":[270,670,0.72]
        }
        this.girl_id=girl_id;
        this.x=girl_pos[girl_id][0];
        this.y=girl_pos[girl_id][1];
        if(typeof girl_pos[girl_id][2]!="undefined"){
            this.scale.set(girl_pos[girl_id][2]);
        }
        
        this.autoUpdate = false;
        
        
        this.myAnimLoop='standby';
        var i,bum;
        for(i in this.state.data.skeletonData.animations){
            bum=this.state.data.skeletonData.animations[i];
            if(bum.name==this.myAnimLoop){
                this.howlongAnim=bum.duration;
                break;
            }
        }
//        this.howlongAnim=this.state.getCurrent(0);
        
        
        //hit;
        this.animeQueue=[];
        this.curAnimName=this.myAnimLoop;
        this.state.setAnimation(0, this.myAnimLoop, true);
        
        this.waitOnHit=0;
        this.hitTime=0;
        this.soundTime=0;
        
        
        var thc=this;
       
        this.state.addListener({
            complete: function() {
                thc.state.setAnimation(0, thc.myAnimLoop, false);
                thc.curAnimName=thc.myAnimLoop;
            }
        });
        
    };
    spineGirl.prototype = Object.create(PIXI.spine.Spine.prototype);
    spineGirl.prototype= $.extend(spineGirl.prototype,{
        willBeHit:function(howlong_sound,howlong_hit){
            this.soundTime=howlong_sound;
            this.hitTime=howlong_hit;
            
            this.waitOnHit=0;
        },
        updateState:function(delta){
            var mili=1/60;
            var howlong=delta*mili;
            
            this.update(howlong);
            if(this.hitTime>0){
                this.waitOnHit+=howlong;
                if(this.soundTime>0 && this.waitOnHit>=this.soundTime){
                    this.soundTime=0;
                    _mySound.playSound("before_punch");
                }
                if(this.waitOnHit>=this.hitTime){
                    this.state.setAnimation(0, "hit", false);
                    _mySound.playSound("punch");
                    if(in_array(this.girl_id,[6,9,8,18,5])){
                        _mySound.playSound("pain_like");
                    }
                    else{
                        _mySound.playSound("pain");
                    }
                    
                    this.hitTime=0;
                }
            }
        }
    });
    
    
    function progressBelt(on_nearly_end,on_end){
        this.texture = PIXI.utils.TextureCache["belt.png"];
        this.conf={fps:60};

        PIXI.Sprite.call(this,this.texture);

        this.conf.width=458;
        this.conf.height=33;

        this.texture.width = this.texture.realWidth = this.conf.width;
        this.texture.height = this.texture.realHeight = this.conf.height;

        this.frameRectangle = new PIXI.Rectangle(0, 0, this.conf.width, this.conf.height);
        this.texture.frame= this.frameRectangle;

        this.x=403;
        this.y=75;
        this.step=0;
        this.step_max=-1;
        this.state="";
        this.on_nearly_end=on_nearly_end;
        this.on_end=on_end;


    }
    progressBelt.prototype = Object.create(PIXI.Sprite.prototype);
    progressBelt.prototype= $.extend(progressBelt.prototype,{
        init:function(conf){
            this.conf=$.extend(this.conf,conf);
        },
        updateState:function(delta){
            this.step+=delta;
            if(this.step_max>0 && this.step>=this.step_max){
                  this.step=this.step_max;  
            }

            if(this.state=="run" && this.step>=0){
                var part=this.step/this.step_max;
                part=Math.min(1,part);

                this.frameRectangle.width=this.conf.width-this.conf.width*part;
                this.texture.frame= this.frameRectangle;

//                this.texture.frame.width=this.conf.width-this.conf.width*part;
//                this.texture._updateUvs();


                if(part>0.8){
                    this.on_nearly_end();
                }
                if(this.step==this.step_max){
                    this.on_end();
                }
            }


            if(this.step==this.step_max){
                this.step_max=-1;
                this.state="";
            }
        },
        startBelt:function(howlong,step){
            if(!step){
                step=0;
            }
            this.state="run";
            this.step=step;

            this.step_max=Math.ceil(howlong/(1000/this.conf.fps));
        },
        stopBelt:function(){
            this.step_max=-1;
            this.state="";
//            this.texture.frame.width=this.conf.width;
        }

    });
    
    function textBox(x, y,text) {
        PIXI.Container.call(this);
        this.x=x;
        this.y=y;
        var width=171;
        var height=40;
        this.width=width;
        this.height=height;

        this.margin=[width/2,height/2];
        this.fontColor="#ffffff";
        var style = new PIXI.TextStyle({
            fontFamily: "Gochi Hand, cursive",
            fontSize: 42,
            fill: this.fontColor
        });
        
        
        this.pivot.set(this.margin[0],height);

        
        this.textObj= new PIXI.Text(text,style);
        this.textObj.anchor.set(0.5,0.5);
        this.textObj.x=this.margin[0];
        this.textObj.y=this.margin[1];  

        this.addChild(this.textObj);
    };
    textBox.prototype = Object.create(PIXI.Container.prototype);
    textBox.prototype= $.extend(textBox.prototype,{
        setText:function(text){
            this.textObj.text=text;
        },
        setSucc:function(){
            this.textObj.style.fill="#519740";
        }
    });
    
    
    function cardBox(x, y,index) {
        PIXI.Container.call(this);
        this.x=x;
        this.y=y;
        this.index=index;

        var cardTexture = PIXI.utils.TextureCache["card"+mt_rand(1,3)];
        this.cardImg=new PIXI.Sprite(cardTexture);
        this.addChild(this.cardImg);
        
        this.fontConf={
            "normal":{fill:"#2c487f",stroke:'#f7c480'},
            "premium":{fill:"#2c487f",stroke:'#f075c1'}
        }

        this.margin=[this.width/2,this.height/2];
        this.fontColor="#2c487f";
        var style = new PIXI.TextStyle({
            fontFamily: "Gochi Hand, cursive",
            fontSize: 32,
            fill: this.fontColor,
            stroke: '#f7c480',
            strokeThickness: 5
        });
        this.textObj= new PIXI.Text("1222",style);
        this.textObj.anchor.set(0.5,0.5);
        this.textObj.x=this.margin[0];
        this.textObj.y=this.margin[1];  



        this.addChild(this.textObj);

        this.pivot.set(0,0);
        this.rotation=Math.PI*mt_rand(-35,35)/1000;


        this.alpha=0;

        this.state="";
        this.step=0;
        this.step_max=-1;

        this.val=0;
        this.newState=0;

    };
    cardBox.prototype = Object.create(PIXI.Container.prototype);
    cardBox.prototype= $.extend(cardBox.prototype,{
        init:function(on_click){
            this.on('pointerdown', function(){
                on_click(this.index);
                _mySound.playSound("card");
//                _mySound.playSound("click_tiny");
            });
        },
        takeState:function(){
          return this.state;  
        },
        setFail:function(){
            this.textObj.style.fill="red";
        },
        setWinGame:function () {
            this.textObj.style.fill="green";
        },
        setNumber:function(val,type){
            this.val=val;
            var font_size=40;
            var len2size={
                "5":36,
                "6":32,
                "7":28
            };
            var len=val.toString().length,i,key;
            for(i in len2size){
                key=intval(i);
                if(len>=key){
                    font_size=len2size[i];
                }
            }
            var add_random=0;
            if(type=="premium"){
                add_random=3;
            }
            var cardTexture = PIXI.utils.TextureCache["card"+mt_rand(1+add_random,3+add_random)];
            this.cardImg.texture=cardTexture;
            this.textObj.text=val;
            this.textObj.style.fontSize=font_size;
            
            this.textObj.style.fill=this.fontConf[type].fill;
            this.textObj.style.stroke=this.fontConf[type].stroke;
        },
        setState:function(name,step){
            if(name=="hide" && this.alpha==0){
                return false;
            }
            if(!step){
                step=0;
            }
            this.state=name;
            this.step=step;
            if(name=="show" || name=="hide"){
                this.step_max=30;

            }
            if(name=="hide"){
                this.interactive = false;
                this.buttonMode = false;
            }
            if(name=="show"){
                this.newState=1;
                this.interactive = true;
                this.buttonMode = true;
            }
            if(name=="stop"){
                this.step_max=-1;
                this.state="";
            }
            return true;
        },
        updateState:function(delta){
            this.step+=delta;
            if(this.step_max>0 && this.step>=this.step_max){
                  this.step=this.step_max;  
            }
            if(this.state=="hide" || this.state=="show"){
                var alpha;
                if(this.state=="hide"){
                    alpha=1-(this.step/this.step_max);
                }
                else{
                    if(this.newState>0 && this.step>0){
                        this.newState=0;
                        _mySound.playSound("click_tiny");
//                        _mySound.playSound("card");
                    }
                    alpha=Math.max(0,this.step/this.step_max);
                }
                this.alpha=alpha;
            }




            if(this.step==this.step_max){
                this.step_max=-1;
                this.state="";
            }
        }
    });

    var loaderOptions = {
        crossOrigin: true
    };
    var loaderMain = new PIXI.loaders.Loader();
    var girl_name=$.takeGirlImage(game_conf.girl_id);
    var spineLoaderOptions = { metadata: { spineAtlasSuffix: '.atlas?11' } };
    loaderMain
    .add('card1', _IMG_SERV+"/gfx/place/teachergame/game/card1.png",loaderOptions)
    .add('card2', _IMG_SERV+"/gfx/place/teachergame/game/card2.png",loaderOptions)
    .add('card3', _IMG_SERV+"/gfx/place/teachergame/game/card3.png",loaderOptions)
    .add('card4', _IMG_SERV+"/gfx/place/teachergame/game/card4.png",loaderOptions)
    .add('card5', _IMG_SERV+"/gfx/place/teachergame/game/card5.png",loaderOptions)
    .add('card6', _IMG_SERV+"/gfx/place/teachergame/game/card6.png",loaderOptions)
    .add("girlGM", _IMG_SERV+"/gfx/place/teachergame/game/girls/"+girl_name+"/skeleton.json")
    .add('table', _IMG_SERV+"/gfx/place/teachergame/gameplay/table.png",loaderOptions)
    .add('belt.png', _IMG_SERV+"/gfx/place/teachergame/gameplay/belt.png",loaderOptions)
    .add('teacherGM', _IMG_SERV+'/gfx/place/teachergame/game/teacher/skeleton.json')
    .load(function(loader, resources){

        spineResources=resources;
        thm.gameObj=new teacherGame(appObj,game_conf);
        thm.gameObj.init();
    });
    _moduleEvents.one("moduleClear",function(){
        loaderMain.reset();
    });


};
gameTeacher.prototype={
    start:function(){
        this.gameObj.nextGame();
    },
    takeState:function(){
        return this.gameObj.takeState();
    },
    updateState:function(obj){
        this.gameObj.state={val_best:obj.val,moves:obj.moves,val_need:0,was_error:0};
    }
};

